import { render, staticRenderFns } from "./SpeechInputBox.vue?vue&type=template&id=0ca9d60f&"
import script from "./SpeechInputBox.vue?vue&type=script&lang=js&"
export * from "./SpeechInputBox.vue?vue&type=script&lang=js&"
import style0 from "./SpeechInputBox.vue?vue&type=style&index=0&id=0ca9d60f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports